import { Component, OnInit, Input, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { QuotService } from '../../services/quot.service';
import { ActivityService } from '../../services/activity.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { KeyPersonsService } from '../../services/key-persons.service';
import { EmployeeService } from '../../services/employee.service';
import { ActivityClassificationService } from '../../services/activity-classification.service';

import { QuotationActivityFunctions, QuotationFunctionData } from '../../quotation-activity-functions';
import { Subscription } from 'rxjs';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { UnitService } from '../../services/unit.service';
import { ProductionOrderData } from '../../services/production-order.service';

@Component({
  selector: 'app-update-quot',
  templateUrl: './update-quot.component.html',
  styleUrls: ['./update-quot.component.css']
})
export class UpdateQuotComponent implements OnInit, OnDestroy {
  loading: boolean[] = Array(6).fill(false);
  get loaded(): boolean { return !this.loading.includes(false); }

  quotId;
  quot: any = {};
  prVnta: any = {};
  
  activityIsGeneral: boolean;
  activityDataCalc: string;
  activityRanges: any[];
  labels: string[];
  activityFunction: any;

  customerError: boolean = false;
  employeeSignError: boolean = false;

  quotForm: FormGroup;
  sectionForm: FormGroup;
  activityForm: FormGroup;

  sections: any[];
  generalActivities: any[];
  quantitiesObjs: any[] = [];
  quantities: any[];

  activities;
  customers;
  keyPersons;
  employees;
  classifications;

  activityUnique = {
    papel: {prCmpaId: '', prCmpaDescription: '', hilo: this.odpData.hiloOptions[0], mermas: []},
    fleteLocal: {laps: []},
    pegado: {pasteType: '6'}
  }
  uniqueInit = {
    papel: undefined,
    papelData: {}
  }
  get papelPrices() { let name = this.activityUnique.papel.prCmpaDescription; return this.uniqueInit.papelData[name] && this.uniqueInit.papelData[name].prices || [] }

  activitiesInit: any;
  activitiesInits: any;
  customersInit: any;
  keyPersonsInit: any;
  keyPersonsInits: any;
  employeesInit: any;
  classificationInit: any;
  classificationInits: any;

  modalActionsSection = new EventEmitter<string|MaterializeAction>();
  modalParamsSection = [{dismissible: true}];
  modalActionsActivity = new EventEmitter<string|MaterializeAction>();
  modalParamsActivity = [{dismissible: true}];
  
  currentSectionTab: number;
  currentSectionShowing: boolean;
  currentActivityEdit: number;

  modalPurpose: string = 'add';

  activityFunctionDatas: any;
	generalfunctionSelects: any[];
  sectionfunctionSelects: any[];
  
  pickadateParams = Utils.pickadateParams();

  defaultIva: number;
  utilityQuot: number;
  mermaQuot: number;
  fixedQuot: number;
  commissionQuot: number;

  sortablejsOptions;

  subs: Subscription[] = [];
  subsToDie: Subscription[] = [];

  constructor(
    private service: QuotService,
    private activityService: ActivityService,
    private customerService: CustomerSupplierService,
    private keyPersonService: KeyPersonsService,
    private employeeService: EmployeeService,
    private prCmpaService: ProductCmpaService,
    private unitService: UnitService,
		private activityClassificationService: ActivityClassificationService,
    private quotationFunctionData: QuotationFunctionData,
    public odpData: ProductionOrderData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.quotId = this.activatedRoute.snapshot.paramMap.get('id');
    this.quot = {};

    this.sortablejsOptions = {
      onUpdate: (event: any) => {
        this.quantities = this.quantitiesObjs.map(({q}) => q);
        this.updateAllQuantityPrices();
        this.updateFinalTable();
      }
    }

    this.quantities = [];
    this.sections = [];
    this.generalActivities = [];
    this.activityFunctionDatas = this.quotationFunctionData.functionData;
    this.activityFunction = {};
    this.generalfunctionSelects = [];
		this.sectionfunctionSelects = [];
		quotationFunctionData.selectArray.map(data => {
			if(data.isGeneral) this.generalfunctionSelects.push(data);
			else this.sectionfunctionSelects.push(data);
    })
    this.subs.push(
      this.activityService.getActivities({onEmpty: ()=>{ this.loading[0] = true} }).subscribe(activities => {
        this.activities = {};
        this.activitiesInits = { 'section': {data: {}}, 'general': {data: {}}, };
        const data = activities.reduce((acc, cur) => {
          const type = cur.activityClassObj.perSection ? 'section' : 'general';
          this.activitiesInits[type].data[`${cur.name.trim()}`] = null;
          this.activities[`${cur.name.trim()}`] = this.activities[`${cur.id}`] = {
            ...cur,
            classification: cur.activityClassObj.name,
            quantityPricesFunction: cur.quantityPricesFunction || '',
            unique: cur.unique || {},
            actId: cur.id
          };
          return acc;
        }, {});
        this.loading[0] = true;
      })
    );
    this.subs.push(
      this.customerService.getCustomers({onEmpty: ()=>{ this.loading[1] = true} }).subscribe(customers => {
        this.customers = {};
        this.keyPersons = {};
        this.keyPersonsInits = {};
        const data = customers.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.customers[`${cur.name.trim()}`] = cur.id$;
          this.customers[`${cur.id$}`] = cur.name.trim();
          return acc;
        }, {});
        console.log(this.customers)
        this.customersInit = { 'data': data };
        customers.map((customer, index) => {
          this.subsToDie[index] = this.keyPersonService.getKeyPersons(customer.id$, 'customerId').subscribe(keyPersons => {
            const data = keyPersons.reduce((acc, cur) => {
              acc[`${cur.name.trim()}`] = null;
              this.keyPersons[`${cur.name.trim()}`] = this.keyPersons[`${cur.id}`] = { ...cur, name: cur.name.trim() };
              return acc;
            }, {});
            this.keyPersonsInits[customer.id$] = { 'data': data };
            this.subsToDie[index].unsubscribe();
          });
        });
        this.loading[1] = true;
      })
    );
    this.subs.push(
      this.employeeService.getEmployees({onEmpty: ()=>{ this.loading[2] = true} }).subscribe(employees => {
        this.employees = {};
        const data = employees.reduce((acc, cur) => {
          acc[`${cur.name.trim()} ${cur.lastName.trim()}`] = null;
          this.employees[`${cur.name.trim()} ${cur.lastName.trim()}`] = cur.id$;
          this.employees[`${cur.id$}`] = cur.name.trim();
          return acc;
        }, {});
        this.employeesInit = { 'data': data };
        this.loading[2] = true;
      })
    );
    this.subs.push(
      this.activityClassificationService.getActivityClassifications({onEmpty: ()=>{ this.loading[3] = true} }).subscribe(tempClassifications => {
        this.classifications = {};
        this.classificationInits = { 'section': {data: {}}, 'general': {data: {}}, };
        for (const idx in tempClassifications) {
          const type = tempClassifications[idx].perSection ? 'section' : 'general';
          this.classificationInits[type].data[`${tempClassifications[idx].name.trim()}`] = null;

          this.classifications[tempClassifications[idx].name] = { id: tempClassifications[idx].id$, isGeneral: !tempClassifications[idx].perSection };
          this.classifications[tempClassifications[idx].id$] = { name: tempClassifications[idx].name, isGeneral: !tempClassifications[idx].perSection };
        }
        this.loading[3] = true;
      })
    );
    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      let prCmpasSub = this.prCmpaService.getPrCmpas({onEmpty: ()=>{ this.loading[4] = true}, getCashed: true }).subscribe(prCmpas => {
        const data = prCmpas.reduce((acc, cur) => {
          cur.characs = !cur.characs.reduce ? cur.characs : cur.characs.reduce((acc2, cur2, index) => {
            let unit = units.find(({id}) => id == cur2.unitId.id);
            let symbol = unit ? unit.symbol : '';
            return acc2 + `${index ? ', ' : ''}${cur2.name}: ${cur2.value}${symbol}`;
          }, '');
          acc[`${cur.name} - ${cur.characs}`] = null;
          this.uniqueInit.papelData[`${cur.name} - ${cur.characs}`] = {...cur};
          return acc;
        }, {});
        this.uniqueInit.papel = { 'data': data };
        this.loading[4] = true;
      });
      this.subs.push(prCmpasSub);
    });
  }

  ngOnInit() {
    this.createForm();
    this.createSectionForm();
    this.createActivityForm();
    let subQuot = this.service.getQuot(this.quotId).subscribe(([quot]) => {
      this.quot = quot;
      this.prVnta.id = quot.prVntaObj.id;
      this.prVnta.name = quot.prVntaObj.name;
      this.quotForm.patchValue(quot);
      this.quotForm.get('customerName').patchValue(quot.customerObj.name);
      this.updateKeyPersonsInit();
      this.quotForm.get('employeeSignName').patchValue(`${quot.employeeSignObj.name.trim()} ${quot.employeeSignObj.lastName.trim()}`);
      this.quotForm.get('createdByName').patchValue(`${quot.createdByObj.name} ${quot.createdByObj.lastName}`);
      this.quantities = quot.quantities;
      this.sections = quot.sections || [];
      this.generalActivities = quot.generalActivities || [];
      this.finalTableHeaders = quot.finalTableHeaders || [];
      this.finalTableRows = quot.finalTableRows ? quot.finalTableRows.map(row => row.row) : [];

      this.quantitiesObjs = this.quantities.map((q, qIndex) => ({
        q,
        u: quot.pricePerUnits[qIndex] ? 0 : this.finalTableRows[qIndex][this.finalTableRows[qIndex].length-6],
        p: quot.pricePerUnits[qIndex] || 0,
      }) );

      this.mermaQuot = quot.merma;

      subQuot.unsubscribe();
      this.updateAllQuantityPrices();
      this.updateFinalTable();
      this.loading[5] = true;
    });
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    })
  }
  get Math(){ return Math };
  MathCeil(value: number | string){ return !isFinite(+value) ? 'Infinito' : this.Math.ceil(+value || 0) };

  createForm() {
    this.quotForm = this.fb.group({
      folio: ['', Validators.required],
      date: ['', Validators.required],
      status: ['', Validators.required],
      shortDescription: '',
      deliveryCommitment: '',
      longDescription: '',
      quantity: '',
      iva: '',
      utility: '',
      fixed: '',
      commission: '',
      merma: '',
      payConditions: '',
      notes: '',
      notesPrivate: '',

      customerName: ['', Validators.required],
      keyPersonName: '',
      keyPersonJob: '',
      employeeSignName: ['', Validators.required],
      createdByName: ''
    });
  }
  createSectionForm() {
    this.sectionForm = this.fb.group({
      name: ['', Validators.required],
      width: ['', Validators.required],
      height: ['', Validators.required],
      sizeInPaper: ['', Validators.required],
      pieceInSize: ['', Validators.required],
      frontInk: ['', [Validators.required, Validators.max(8)]],
      backInk: ['', [Validators.required, Validators.max(8)]],
      sheetWidth: ['', Validators.required],
      sheetHeight: ['', Validators.required],
      numPages: ['', Validators.required],
      pieceHeight: ['', Validators.required],
      pieceLong: ['', Validators.required],
      pieceWidth: ['', Validators.required],
      changes: [1, Validators.required],
    })
  }
  createActivityForm() {
    this.activityForm = this.fb.group({
      name: ['', Validators.required],
			classification: ['', Validators.required],
      quantityPricesFunction: ['', Validators.required],
      prices: this.fb.array([]),
      minRange: '',
      maxRange: '',
      rangePrice: ''
    })
  }
  get qpFunction(){ return this.activityForm.get('quantityPricesFunction').value; }
  
  onChangeKeyPerson(name){
    if(this.keyPersons[name]) this.quotForm.get('keyPersonJob').patchValue(this.keyPersons[name].job);
  }
  currentActId: string = '';
  onChangeAName(name){
    if(this.activities[name]){
      var activity = this.activities[name];
      this.currentActId = activity.actId;
      if(activity.quantityPricesFunction == 'papel') this.activityUnique.papel.prCmpaDescription = activity.unique && activity.unique.prCmpaDescription || '';
      if(activity.quantityPricesFunction == 'papel') this.activityUnique.papel.prCmpaId = activity.unique && activity.unique.prCmpaId || '';
      this.activityDataCalc = activity.dataCalc;
      this.activityForm.get('classification').patchValue(activity.classification);
      this.activityForm.get('quantityPricesFunction').patchValue(activity.quantityPricesFunction);
      this.activityFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
      this.activityRanges = activity.ranges;
      while(this.prices.length > 0) this.prices.removeAt(0);
      if(activity.dataCalc > 0){
        this.labels = this.activityFunction.labels;
        [...Array(this.quotationFunctionData.functionData[this.qpFunction].dataCalc)].map((u, index) => {
        //activity.prices.map(number => {
          this.prices.push(this.fb.group({price: activity.prices[index] || 0}));
        });
      }
    }
  }
  onChangeAFunction(functionName){
    this.activityFunction = this.activityFunctionDatas[functionName];
    this.activityDataCalc = this.activityFunction.dataCalc;
    while(this.prices.length > 0) this.prices.removeAt(0); //reset prices por pushing
		this.labels = this.activityFunction.labels;
		if(this.activityFunction.dataCalc > 0 ) for(var i = 0; i < this.activityFunction.dataCalc; i++) this.prices.push(this.priceForm());
  }

  touchActivityRange(){
    const min = Math.abs(+this.activityForm.get('minRange').value);
    const max = Math.abs(+this.activityForm.get('maxRange').value);
    const price = Math.abs(+this.activityForm.get('rangePrice').value);
    if(!isNaN(min) || !isNaN(max) || !isNaN(price)){
      this.activityRanges.push({
        min: min,
        max: max,
        price: price
      });
      this.activityForm.get('minRange').reset();
      this.activityForm.get('maxRange').reset();
      this.activityForm.get('rangePrice').reset();
    }
  }
  removeActivityRange(index){
    this.activityRanges.splice(index,1);
  }
  getActivityQuantityPrices(isGeneral: boolean, activity, sectionIndex?: number) {
    const section = isGeneral ? {} : this.sections[sectionIndex];
    if(!isGeneral) var {unique:{mermas=[]}={mermas: []}} = this.sections[sectionIndex].activities.find(({unique={mermas:undefined}}: any) => unique.mermas) || {};
    var globalFucntions = new QuotationActivityFunctions(
      this.quantities,
      activity,
      section,
      mermas || new Array(6).fill(this.quotForm.get('merma').value),
    );
    //if(activity.actId == 'BEnUaaNq4GuF7qTyJlQf') console.log(globalFucntions.quantityPrices)
    return globalFucntions.quantityPrices;
  }

  touchSection({ value, valid }: { value: any, valid: boolean }){
    if(this.modalPurpose == 'add'){
      if(this.sections.length && confirm('¿Vaciar activades?')) value.activities = JSON.parse(JSON.stringify(this.sections[0].activities));
      else value.activities = [];
      this.sections.push(value);
    }else{
      value.activities = this.sections[this.currentSectionTab].activities;
      this.sections[this.currentSectionTab] = value;
      this.updateAllQuantityPrices();
      this.updateFinalTable();
    } 
    this.closeModalSection();
  }
  removeSection(index) {
    this.sections.splice(index, 1);
    this.updateFinalTable()
  }
  changeSectionTab(index) {
    if(this.currentSectionTab == index) this.currentSectionShowing = !this.currentSectionShowing;
    else{
      this.currentSectionTab = index;
      this.currentSectionShowing = true;
    }
  }

  touchQuantity(quantity: number) {
    if(this.quantities.length < 6){
      if(quantity){
        this.quantitiesObjs.push({
          q: Math.abs(quantity),
          u: this.quotForm.get('utility').value,
          p: 0
        });
        this.quantities = this.quantitiesObjs.map(({q}) => q);        

        this.quotForm.get('quantity').reset();
        this.updateAllQuantityPrices();
        this.updateFinalTable();
      }else{
        toast('Ingrese una cantidad válida.',3000);
      }
    }else{
      toast('Máximo seis cantidades', 3000);
    }
  }
  removeQuantity(index) {
    this.quantitiesObjs.splice(index, 1);
    this.quantities = this.quantitiesObjs.map(({q}) => q);
    this.updateAllQuantityPrices();
    this.updateFinalTable();
  }

  touchActivity({ value, valid }: { value: any, valid: boolean }) {
    console.log(`Created activity`)
    var activity = value;
    console.log(activity)
	  activity.actId = this.currentActId;
    activity.dataCalc = this.activityDataCalc;
    if(activity.dataCalc === 0){
      activity.ranges = this.activityRanges;
      activity.prices = [];
    }else if(activity.dataCalc > 0){
      activity.prices = value.prices.map(object => object.price);
      activity.ranges = [];
    }
    delete activity.minRange;
    delete activity.maxRange;
    delete activity.rangePrice;

    if(this.quotationFunctionData.functionData[this.qpFunction].hasUnique) activity.unique = {...this.activityUnique[this.qpFunction] || {}};
	  let {id=''} = activity.unique && this.uniqueInit.papelData[activity.unique.prCmpaDescription] || {};
	  if(id) activity.unique.prCmpaId = id;

    activity.quantityPrices = this.getActivityQuantityPrices(this.activityIsGeneral, activity, this.currentSectionTab);
    console.log(activity.quantityPrices)

    if(this.activityIsGeneral){
      if(this.modalPurpose == 'add') this.generalActivities.push(activity);
      else this.generalActivities[this.currentActivityEdit] = activity;
    }else{
      //console.log(this.sections); // No borrar por favor :(
      if(this.modalPurpose == 'add') this.sections[this.currentSectionTab].activities.push(activity);
      else this.sections[this.currentSectionTab].activities[this.currentActivityEdit] = activity;
    }
    //console.log(this.sections[this.currentSectionTab].activities)
    this.updateAllQuantityPrices();
    this.updateFinalTable();
    this.closeModalActivity();
  }
  removeActivity(isGeneral: boolean, index: number) {
    let acts = isGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities;
    if(!confirm(`¿Borrar la actividad ${acts[index].name}?`)) return;
    acts.splice(index, 1);
    this.updateFinalTable();
  }
  
  onSubmit({ value, valid }: { value: any, valid: any }) {
    var quot = value;

    console.log(`${quot.customerName}`);
    console.log(Object.keys(this.customers))
    console.log(window['cus'] = this.customers)
    console.log(window['cusn'] = quot.customerName)
    console.log(this.customers[quot.customerName])
    this.customerError = !this.customers[quot.customerName];
    this.employeeSignError = !this.employees[quot.employeeSignName];
    if(this.customerError || this.employeeSignError) return;

    //Variables actually hold id for later conversion to reference
    quot.customerRef = this.customers[quot.customerName];
    quot.employeeSignRef = this.employees[quot.employeeSignName];
    quot.prVntaRef = this.prVnta.id;
    
    delete quot.customerName;
    delete quot.employeeName;
    delete quot.createdByName;
    
    delete quot.quantity;

    quot.quantities = this.quantities;
    quot.pricePerUnits = this.quantitiesObjs.map(({p}, i) => p || this.finalTableRows[i][this.finalTableRows[i].length-3]);
    quot.sections = this.sections;
    quot.generalActivities = this.generalActivities;
    quot.finalTableHeaders = this.finalTableHeaders ? this.finalTableHeaders : [];
    quot.finalTableRows = this.finalTableRows ? this.finalTableRows.map(row => ({row: row})) : [];
    
    this.service.updateQuot(this.quotId, quot);
    this.service.windowReplace('view', this.quotId);
  }

  openModalSection(action: string, index?: number) {
    this.modalPurpose = action;
    this.createSectionForm();
    if(action == 'edit'){
      this.currentSectionShowing = true;
      this.currentSectionTab = index;
      var section = this.sections[index];
      this.sectionForm.patchValue(section);
    }
    this.modalActionsSection.emit({ action: 'modal', params: ['open'] });
  }
  closeModalSection() {
    this.modalActionsSection.emit({ action: 'modal', params: ['close'] });
  }
  openModalActivity(action: string, isGeneral: boolean, index?: number) {
    this.currentActId = '';
    while(this.prices.length > 0) this.prices.removeAt(0);
    this.modalPurpose = action;
    this.activityForm.reset();
    this.activityFunction = {};
    this.activityDataCalc = '';
    this.activityRanges = [];
    this.activityIsGeneral = isGeneral;
    const type = isGeneral ? 'general' : 'section';
    this.activityUnique.papel = {mermas: [...Array(6)].map(a=>this.mermaQuot), prCmpaDescription: '', prCmpaId: '', hilo: this.odpData.hiloOptions[0]};
    this.activityUnique.fleteLocal = {laps: [...Array(6)].map(a=>0)};
    this.updateActivitiesInit(type);
    this.updateClassificationInit(type);
    if(action == 'edit'){
      this.currentActivityEdit = index;
      var activity = isGeneral ? this.generalActivities[index] : this.sections[this.currentSectionTab].activities[index];
			this.currentActId = activity.actId || '';
      this.activityDataCalc = activity.dataCalc;
      this.activityForm.get('name').patchValue(activity.name);
      this.activityForm.get('classification').patchValue(activity.classification);
      this.activityForm.get('quantityPricesFunction').patchValue(activity.quantityPricesFunction);
      this.activityFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
      if(activity.quantityPricesFunction == 'papel') this.activityUnique.papel = {...this.activityUnique.papel, ...activity.unique};
      if(activity.quantityPricesFunction == 'fleteLocal') this.activityUnique.fleteLocal = {laps: [...Array(6)].map((a,i)=>((activity.unique||{}).laps||[])[i] || activity.prices[1] || 0)};
      this.activityRanges = activity.ranges;
      if(activity.dataCalc > 0){
        this.labels = this.activityFunction.labels;
        [...Array(this.quotationFunctionData.functionData[this.qpFunction].dataCalc)].map((u, index) => {
        //activity.prices.map(number => {
          this.prices.push(this.fb.group({price: activity.prices[index] || 0}));
          console.log(this.activityForm.get('prices').value);
        });
      }
    }else{
      if(this.activityIsGeneral) var array = this.generalfunctionSelects;
      else var array = this.sectionfunctionSelects;
      this.activityForm.get('quantityPricesFunction').patchValue(array[0].value);
      this.onChangeAFunction(array[0].value);
    }
    this.modalActionsActivity.emit({ action: 'modal', params: ['open'] });
  }
  closeModalActivity() {
    this.modalActionsActivity.emit({ action: 'modal', params: ['close'] });
  }

  updateKeyPersonsInit(){
    const customerName = this.quotForm.get('customerName').value;
    const customerId = this.customers[customerName] ? this.customers[customerName] : '';
    this.keyPersonsInit = customerId ? this.keyPersonsInits[customerId] : {};
    this.quotForm.get('keyPersonName').reset();
  }
  updateActivitiesInit(type){
    this.activitiesInit = this.activitiesInits[type];
  }
  updateClassificationInit(type){
    this.classificationInit = this.classificationInits[type];
  }

  tooltipIsShowing = [];
  generalTooltipIsShowing = [];
  tooltipActivity(activity){
    switch(activity.quantityPricesFunction){
      case "papel":
        //console.log(`PiS: ${this.sections[this.currentSectionTab].pieceInSize}, SiP: ${this.sections[this.currentSectionTab].sizeInPaper}, M: ${this.activityUnique.papel.mermas.join(',')}`);
        let paperToBuy = this.quantitiesObjs.map((cur, ind) => `${cur.q} piezas: ${this.MathCeil( (+cur.q/((this.sections[this.currentSectionTab].pieceInSize*this.sections[this.currentSectionTab].sizeInPaper) || 1) * (1 + +(this.activityUnique.papel.mermas[ind] || this.quotForm.get('merma').value)/100)) )} hojas`).join(', ');
        return `${activity.unique.prCmpaDescription}, $${activity.prices[0]}\nHojas a comprar: ${paperToBuy}`;
      default: return "";
    }
  }

  get prices(): FormArray {
		return this.activityForm.get('prices') as FormArray;
	}
	priceForm(){
		return this.fb.group({
			price: ['', Validators.required]
		});
	}

  finalTableRows: any[] = [];
  getFinalTableRows(){
    const byName = name => this.finalTableHeaders.indexOf(name);
    const columnPrices = name => columns[byName(name)].quantityPrices;
    var columns: any[] = this.finalTableHeaders.map(header => {
      return { name: header, quantityPrices: this.quantities.map(quantity => { return 0; }) }
    });
    this.sections.map(section => {
      section.activities.map(activity => {
        if(!activity.quantityPrices) activity.quantityPrices = [];
        activity.quantityPrices.map( (price, pIndex) => {
          columns[byName(activity.classification)].quantityPrices[pIndex] += price;
          columns[byName('Costo total')].quantityPrices[pIndex] += price;
        });
      });
    });
    this.generalActivities.map(activity => {
      if(!activity.quantityPrices) activity.quantityPrices = [];
      activity.quantityPrices.map( (price, pIndex) => {
        columns[byName(activity.classification)].quantityPrices[pIndex] += price;
        columns[byName('Costo total')].quantityPrices[pIndex] += price;
      });
    });
    let fixed = this.quotForm.get('fixed').value;
    let commission = this.quotForm.get('commission').value;
    columns[byName('Costos fijos')].quantityPrices = columnPrices('Costo total').map( (price) => price*fixed/100);

    //forward --->
    columns[byName('Utilidad')].quantityPrices = this.quantities.map( (q, qIndex) => !this.quantitiesObjs[qIndex].p ? this.quantitiesObjs[qIndex].u : 0);
    let utilityTotals = columnPrices('Costo total').map( (price, pIndex) => !this.quantitiesObjs[pIndex].p ? (price + columnPrices('Costos fijos')[pIndex])*((100 + this.quantitiesObjs[pIndex].u)/100)  : 0);
    columns[byName('Comisión')].quantityPrices = utilityTotals.map( (price, pIndex) => !this.quantitiesObjs[pIndex].p ? price*(commission/100)  : 0);
    columns[byName('Precio')].quantityPrices = utilityTotals.map( (price, pIndex) => !this.quantitiesObjs[pIndex].p ? price*(100 + commission)/100  : 0);
    columns[byName('Precio x Pza')].quantityPrices = columnPrices('Precio').map( (price, pIndex) => price/this.quantities[pIndex]);

    //backward <---
    columns[byName('Precio x Pza')].quantityPrices = columnPrices('Precio x Pza').map( (p, i) => p || this.quantitiesObjs[i].p);
    columns[byName('Precio')].quantityPrices = columnPrices('Precio').map( (p, i) => p || this.quantitiesObjs[i].p*this.quantities[i]);
    columns[byName('Comisión')].quantityPrices = columnPrices('Comisión').map( (p, i) => p || columnPrices('Precio')[i]/((100 + commission)/100)*(commission/100));
    columns[byName('Utilidad')].quantityPrices = columnPrices('Utilidad').map( (u, i) => u || ((-columnPrices('Comisión')[i] + columnPrices('Precio')[i])*100/(columnPrices('Costo total')[i] + columnPrices('Costos fijos')[i])) - 100 );

    
    columns[byName(`Iva ${this.defaultIva}%`)].quantityPrices = columnPrices('Precio').map( (price) => price*(this.defaultIva/100));
    columns[byName('Total')].quantityPrices = columnPrices('Precio').map( (price, pIndex) => price + columnPrices(`Iva ${this.defaultIva}%`)[pIndex]);
    return this.quantities.map( (quantity, qIndex) => columns.map(column => column.quantityPrices[qIndex]) );
  }
  finalTableHeaders: string[] = [];
  getFinalTableHeaders(){
    let headers: string[] = [];
    this.sections.map(section => {
      section.activities.map(activity => {
        if(headers.indexOf(activity.classification) == -1) headers.push(activity.classification);
      });
    });
    this.generalActivities.map(activity => {
      if(headers.indexOf(activity.classification) == -1) headers.push(activity.classification);
    });
    headers.push( 'Costo total', 'Costos fijos', 'Utilidad', 'Comisión', 'Precio', 'Precio x Pza', `Iva ${this.defaultIva}%`, 'Total' );
    return headers;
  }
  updateFinalTable(){
    this.defaultIva = this.quotForm.get('iva').value;
    this.finalTableHeaders = this.getFinalTableHeaders();
    this.finalTableRows = this.getFinalTableRows();
  }
  updateAllQuantityPrices(){
    this.generalActivities.map(activity => {
      let {minPrice: mp = 0} = this.activities[activity.name] || this.activities[activity.actId] || {};
      activity.quantityPrices = this.getActivityQuantityPrices(true, activity).map(p => p > mp ? p : mp);
    });
    this.sections.map((section, index) => {
      section.activities.map(activity => {
        let {minPrice: mp = 0} = this.activities[activity.name] || this.activities[activity.actId] || {};
        activity.quantityPrices = this.getActivityQuantityPrices(false, activity, index).map(p => p > mp ? p : mp);
        activity.quantityPrices = activity.quantityPrices.map(n => n || 0)
        console.log(activity.actId, activity.quantityPrices)
      });
    });
  }

  money = Utils.money;


  indexUoP: number = -1;
  utilityUoP: number = 0;
  priceUoP: number = 0;
  modalActionsUoP = new EventEmitter<string|MaterializeAction>();
  modalParamsUoP = [{dismissible: true}];
  openModalUoP(index: number){
    this.indexUoP = index;
    this.utilityUoP = this.quantitiesObjs[index].u;
    this.priceUoP = this.quantitiesObjs[index].p;
    this.modalActionsUoP.emit({ action: 'modal', params: ['open'] });
  }
  closeModalUoP(){
    this.modalActionsUoP.emit({ action: 'modal', params: ['close'] });
  }
  editUoP(){
    this.quantitiesObjs[this.indexUoP].u = this.utilityUoP;
    this.quantitiesObjs[this.indexUoP].p = this.priceUoP;
    this.updateFinalTable();
    this.closeModalUoP();
  }
  
}

//https://www.npmjs.com/package/angular-sortablejs